import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { LogIn, ArrowLeft } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { formatApiError } from "@/lib/api";

export default function AuditLogin() {
  const nav = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.email, form.password);
      toast.success("Sesión iniciada");
      nav(location.state?.from || "/audit", { replace: true });
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div data-surface="audit" className="min-h-screen bg-[hsl(var(--audit-bg))] px-6 py-12">
      <div className="mx-auto max-w-md">
        <Link to="/" data-testid="login-back-home" className="inline-flex items-center gap-1 text-sm text-[hsl(var(--audit-muted))]"><ArrowLeft size={14} /> Web pública</Link>
        <div className="mt-6 rounded-md border border-[hsl(var(--audit-border))] bg-white p-8">
          <div className="text-xs font-mono uppercase tracking-[0.25em] text-[hsl(var(--audit-muted))]">Audit Framework</div>
          <h1 className="mt-1 text-2xl font-bold">Iniciar sesión</h1>
          <form onSubmit={submit} data-testid="audit-login-form" className="mt-6 grid gap-4">
            <label className="block">
              <span className="text-xs font-mono uppercase tracking-widest text-[hsl(var(--audit-muted))]">Correo</span>
              <input required type="email" data-testid="audit-login-email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1 w-full rounded-md border border-[hsl(var(--audit-border))] px-3 py-2 text-sm" />
            </label>
            <label className="block">
              <span className="text-xs font-mono uppercase tracking-widest text-[hsl(var(--audit-muted))]">Contraseña</span>
              <input required type="password" data-testid="audit-login-password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="mt-1 w-full rounded-md border border-[hsl(var(--audit-border))] px-3 py-2 text-sm" />
            </label>
            <button type="submit" disabled={loading} data-testid="audit-login-submit" className="inline-flex items-center justify-center gap-2 rounded-md bg-[hsl(var(--audit-text))] px-4 py-2 text-sm font-semibold text-white disabled:opacity-50">
              <LogIn size={14} /> {loading ? "Entrando…" : "Entrar"}
            </button>
          </form>
          <p className="mt-4 text-sm text-[hsl(var(--audit-muted))]">
            ¿No tienes cuenta? <Link to="/audit/signup" data-testid="audit-signup-link" className="font-semibold text-[hsl(var(--audit-text))] underline">Regístrate</Link>
          </p>
          <p className="mt-6 rounded-md bg-[hsl(var(--audit-bg))] p-3 text-xs font-mono text-[hsl(var(--audit-muted))]">
            Demo: demo@katiafalonodontologia.com / Demo1234!
          </p>
        </div>
      </div>
    </div>
  );
}
